<template>
  <div class="space-y-4">
    <div class="space-y-2">
      <div class="shimmer h-4 w-40 rounded-full" />
      <div
        v-for="i in 3"
        :key="i"
        class="bg-background-neutral-secondary w-full rounded-2xl px-4 py-4"
      >
        <div class="flex items-start justify-between">
          <div class="space-y-2">
            <div class="shimmer h-6 w-28 rounded-xl" />
            <div class="shimmer h-3.5 w-36 rounded-full" />
          </div>
          <div class="shimmer size-9 rounded-xl" />
        </div>
      </div>
    </div>
    <div class="space-y-2">
      <div class="shimmer h-4 w-44 rounded-full" />
      <div
        v-for="i in 3"
        :key="i"
        class="bg-background-neutral-secondary w-full rounded-2xl px-4 py-4"
      >
        <div class="flex items-start justify-between">
          <div class="space-y-2">
            <div class="shimmer h-6 w-28 rounded-xl" />
            <div class="shimmer h-3.5 w-36 rounded-full" />
          </div>
          <div class="shimmer size-9 rounded-xl" />
        </div>
        <div class="mt-3 space-y-3">
          <div class="flex items-center gap-3">
            <div class="shimmer size-6 rounded-full" />
            <div class="shimmer h-4 w-48 rounded-full" />
          </div>
          <div class="flex items-center gap-3">
            <div class="shimmer size-6 rounded-full" />
            <div class="shimmer h-4 w-56 rounded-full" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
